import React from 'react';

import { LinkedActivityCell, LinkedActivityDates } from './linkedActivity';

const SuccessorsTable = ({ successors }) => (
    <div className="inbud-table_wrapper">
        <table className="inbud-table tw-table-fixed">
            <thead>
                <tr>
                    <th>{$t('Activity')}</th>
                    <th className="tw-w-40">{$t('Type')}</th>
                    <th className="tw-w-24">{$t('Lag (days)')}</th>
                    <th className="tw-w-48">{$t('Successor dates')}</th>
                    <th className="tw-w-12"></th>
                </tr>
            </thead>
            <tbody>
                {successors.length === 0 && (
                    <tr>
                        <td colSpan={5} className="tw-text-center tw-text-charcoal-60">
                            {$t('No successors.')}
                        </td>
                    </tr>
                )}
                {successors.map((link) => (
                    <tr key={link.id}>
                        <td>
                            <LinkedActivityCell activity={link.activity} />
                        </td>
                        <td>{link.activity?.visible ? link.type_label : ''}</td>
                        <td>{link.activity?.visible ? link.lag_days : ''}</td>
                        <td>
                            <LinkedActivityDates activity={link.activity} />
                        </td>
                        <td></td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default SuccessorsTable;
